import { MobileTabCasino } from '~components/organisms/MobileTabComponent/MobileTabCasino';
import { MobileTabSport } from '~components/organisms/MobileTabComponent/MobileTabSport';
import { useIsCasinoWebsite } from '~hooks/useIsCasinoWebsite';

export const MobileTabComponent = () => {
  const isCasinoWebsite = useIsCasinoWebsite();

  return isCasinoWebsite ? <MobileTabCasino /> : <MobileTabSport />;
};
